import React, { lazy, } from 'react';
import { Navigate, } from 'react-router-dom';

const PrivacyPolicy = lazy(() => import('../../screens/PrivacyPolicy'));
const NotFound = lazy(() => import('../../screens/NotFound'));
const ClientVerification = lazy(() => import('../../screens/CRM/ClientVerification'));
const ClientOTP = lazy(() => import('../../screens/CRM/ClientOTP'));
const ContractAgreement = lazy(() => import('../../screens/CRM/ContractAgreement'));

const publicRoutes = [
  {
    element: <PrivacyPolicy />,
    path: "/crm/privacy_policy",
  },
  {
    element: <ClientVerification />,
    path: "/crm/verify",
  },
  {
    element: <ClientOTP />,
    path: "/crm/client_otp",
  },
  {
    element: <ContractAgreement />,
    path: "/crm/contract_agreement",
  },
  {
    element: <ContractAgreement />,
    path: "/crm/contract_agreement/:referenceCode",
  },
];

export default publicRoutes;
